"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLICE_PROPERTY_KEYS = exports.PropertyKeySchema = exports.PropertyKey = void 0;
exports.propertyKeyForSlice = propertyKeyForSlice;
const z = require("zod");
const slice_key_1 = require("./slice-key");
var PropertyKey;
(function (PropertyKey) {
    PropertyKey["SigmaModelType"] = "sigma_model_type";
    PropertyKey["Parameters"] = "parameters";
    PropertyKey["Modes"] = "modes";
    PropertyKey["SignalAttributes"] = "signal_attributes";
    PropertyKey["ActiveLow"] = "active_low";
    PropertyKey["Pinout"] = "pinout";
    PropertyKey["FloatingBehaviour"] = "floating_behaviour";
    PropertyKey["SignalTies"] = "signal_ties";
    PropertyKey["AmrBoundaries"] = "amr_boundaries";
    PropertyKey["OcBoundaries"] = "oc_boundaries";
    PropertyKey["DriveModes"] = "drive_modes";
    PropertyKey["Resources"] = "resources";
    PropertyKey["Functions"] = "functions";
})(PropertyKey || (exports.PropertyKey = PropertyKey = {}));
exports.PropertyKeySchema = z.nativeEnum(PropertyKey);
exports.SLICE_PROPERTY_KEYS = {
    [slice_key_1.SliceKey.SigmaModelType]: PropertyKey.SigmaModelType,
    [slice_key_1.SliceKey.ElementSigmaModelType]: PropertyKey.SigmaModelType,
    [slice_key_1.SliceKey.Parameters]: PropertyKey.Parameters,
    [slice_key_1.SliceKey.ElementParameters]: PropertyKey.Parameters,
    [slice_key_1.SliceKey.SignalSet]: PropertyKey.SignalAttributes,
    [slice_key_1.SliceKey.Modes]: PropertyKey.Modes,
    [slice_key_1.SliceKey.SignalAttributes]: PropertyKey.SignalAttributes,
    [slice_key_1.SliceKey.Pinout]: PropertyKey.Pinout,
    [slice_key_1.SliceKey.PinAssignments]: PropertyKey.Pinout,
    [slice_key_1.SliceKey.FloatingBehaviour]: PropertyKey.FloatingBehaviour,
    [slice_key_1.SliceKey.SignalTies]: PropertyKey.SignalTies,
    [slice_key_1.SliceKey.AmrBoundaries]: PropertyKey.AmrBoundaries,
    [slice_key_1.SliceKey.OcBoundaries]: PropertyKey.OcBoundaries,
    [slice_key_1.SliceKey.DriveModes]: PropertyKey.DriveModes,
    [slice_key_1.SliceKey.Resources]: PropertyKey.Resources,
    [slice_key_1.SliceKey.Functions]: PropertyKey.Functions,
    [slice_key_1.SliceKey.FunctionSignalMapping]: PropertyKey.Functions,
    [slice_key_1.SliceKey.Structure]: PropertyKey.SigmaModelType,
    [slice_key_1.SliceKey.SignalMapping]: PropertyKey.Pinout,
    [slice_key_1.SliceKey.NcPins]: PropertyKey.Pinout,
};
function propertyKeyForSlice(sliceKey) {
    const parsed = slice_key_1.SliceKeySchema.safeParse(sliceKey);
    if (!parsed.success) {
        throw new Error(`Unknown slice key: ${sliceKey}`);
    }
    return exports.SLICE_PROPERTY_KEYS[parsed.data];
}
//# sourceMappingURL=property-key.js.map